/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Why_Listening_Combine_BodyInputs */

const en_why_listening_combine_body = /** @type {(inputs: Why_Listening_Combine_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Papers, articles and newsletters, one subscription.`)
};

const es_why_listening_combine_body = /** @type {(inputs: Why_Listening_Combine_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Artículos académicos, artículos y newsletters, una sola suscripción.`)
};

/**
* | output |
* | --- |
* | "Papers, articles and newsletters, one subscription." |
*
* @param {Why_Listening_Combine_BodyInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const why_listening_combine_body = /** @type {((inputs?: Why_Listening_Combine_BodyInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Why_Listening_Combine_BodyInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_why_listening_combine_body(inputs)
	return en_why_listening_combine_body(inputs)
});